<template>
  <ModalDialog v-model="isShow">
    <div class="p-5 field-of-fields" slot="dialog-content">
      <div class="d-flex">
        <h3 class="dialog-title">
          <span>
            {{ title }}
          </span>
        </h3>
      </div>
      <hr style="margin-bottom: 0" />
      <FormGroupRowLayout
        :submitClicked="submitClicked"
        :modelData="data"
        :listFields="listVisibleFields"
        @updatedTime="refreshData()"
        @updatedDate="refreshData()"
        @updatedSelection="handleUpdateSelection($event)"
        @clickMultiSelectBtn="handleClickUserButton($event)"
        @clickTextboxBtn="handleClickTextboxButton($event)"
      >
        <p
          slot="Warning Message"
          class="warning-text"
          v-if="isInvalidBookingDuration"
        >
          {{
            getLabelByKeys(
              "BOOKING_DIALOG.LABEL.INVALID_BOOKING_DURATION",
              shiftRequestMinimumHoursPerClient
            )
          }}
        </p>
        <div slot="Candidate Selection">
          <CandidateSelectionSection
            v-if="hasFillerSelection"
            :listAvailableCandidates="listAvailableCandidates"
            :listPartlyAvailableCandidates="listPartlyAvailableCandidates"
            :listFavoriteCandidateIds="listFavoriteCandidateIds"
            :numberOfBooking="numberOfBooking"
            :booking="data"
            v-model="listSelectedCandidates"
            @selectIndividual="handleClickSelectIndividualBooking()"
          />
          <CandidateSelectionSection
            v-if="hasSelectInterestedCandidateSelection"
            :listAvailableCandidates="listAvailableCandidates"
            :listPartlyAvailableCandidates="listPartlyAvailableCandidates"
            :listFavoriteCandidateIds="listFavoriteCandidateIds"
            :numberOfBooking="numberOfBooking"
            :booking="data"
            :isSelectInterestedCandidate="true"
            v-model="listInterestedCandidates"
          />
        </div>
      </FormGroupRowLayout>
      <BookingPriceInfo
        :job="data"
        :originalJob="passedData"
        :listPrices="listPricesUpsertBooking"
        :user="user"
        :categoryList="categoryList"
        :numberOfAllowedChildren="numberOfAllowedChildren"
        :selectedDate="startDate"
        :columnLayout="false"
        :numberOfBooking="numberOfBooking"
        :numberOfBookingUsingCredit="numberOfBookingUsingCredit"
        :listDateTimesOfJobs="listDateTimesOfJobs"
        :listBookingDates="listBookingDates"
        :isInApplicationForm="isInApplicationForm"
        ref="priceInfo"
      />
      <h4 class="mt-3 mb-0" v-if="chargeClientWhenBooking && $refs.priceInfo">
        Total being charged: {{ agencyCurrencySign
        }}{{ includeCandidatePayment ? getTotalFee() : getAgencyFee() }}
      </h4>
      <StripePayment
        ref="stripePayment"
        v-if="hasPaymentField"
        :user="user"
        :isRequired="true"
        id="card-element2"
        label="Please enter your payment information"
        :submitClicked="submitClicked"
      />
      <div class="p-0" v-if="!hasPresetCandidateSelection">
        <CandidateSelectionSection
          v-if="hasFillerSelection"
          :listAvailableCandidates="listAvailableCandidates"
          :listPartlyAvailableCandidates="listPartlyAvailableCandidates"
          :listFavoriteCandidateIds="listFavoriteCandidateIds"
          :numberOfBooking="numberOfBooking"
          :booking="data"
          v-model="listSelectedCandidates"
          @selectIndividual="handleClickSelectIndividualBooking()"
        />
        <CandidateSelectionSection
          v-if="hasSelectInterestedCandidateSelection"
          :listAvailableCandidates="listAvailableCandidates"
          :listPartlyAvailableCandidates="listPartlyAvailableCandidates"
          :listFavoriteCandidateIds="listFavoriteCandidateIds"
          :numberOfBooking="numberOfBooking"
          :booking="data"
          :isSelectInterestedCandidate="true"
          v-model="listInterestedCandidates"
        />
      </div>
      <hr />
      <div class="button-containers">
        <div class="right-side-button">
          <button
            class="submit-button mylisting-button dark-button"
            data-index="1"
            @click="handleClickSaveButton()"
          >
            {{ getLabelByKeys(isAdd ? "BUTTONS.SUBMIT" : "BUTTONS.SAVE") }}
          </button>
        </div>
        <div class="left-side-button">
          <div class="delete-btn-container">
            <button
              v-if="!isAdd"
              class="mylisting-button danger-button"
              @click="showDeleteBookingConfirmDialog()"
              style=""
            >
              {{ getLabelByKeys("BUTTONS.DELETE") }}
            </button>
          </div>
          <div class="cancel-button-container">
            <button
              class="mylisting-button secondary-button"
              @click="handleClickCloseButton()"
            >
              {{ getLabelByKeys("BUTTONS.CLOSE") }}
            </button>
          </div>
        </div>
      </div>
      <SelectFillerDialog
        v-model="isShowSelectFillerDialog"
        :listDateTimesOfJobs="listDateTimesOfJobs"
        :bookingInfo="bookingDateTimeInfo"
        :listCandidates="listAvailableCandidatesAllBookings"
        :listRelatedAvailabilities="listRelatedAvailabilities"
        :weekAvailabilities="weekAvailabilities"
        :listRelatedJobs="listRelatedJobs"
        :listFavoriteCandidateIds="listFavoriteCandidateIds"
        @selected="mapSelectedCandidates = $event"
      />
    </div>
  </ModalDialog>
</template>
<script>
/*
This component is used for a dialog (add/edit) objects (reference/children/experience/education...)
 */
import axios from "axios";
import {
  FORM_TYPE,
  ACTION_TYPE,
  STRIPE_PAYMENT_ERROR_IDS,
  JOB_STATUSES,
} from "../../../constants/custom-define-type";
import ModalDialog from "../global-dialogs/ModalDialog.vue";
import StripePayment from "../complex-input-elements/StripePayment.vue";
import BookingPriceInfo from "./BookingPriceInfo.vue";
import { mapGetters, mapActions } from "vuex";
import JobFillerInfo from "../JobFillerInfo.vue";
import SelectFillerDialog from "./SelectFillerDialog";
import CandidateSelectionSection from "./CandidateSelectionSection";
import {
  CANCELLING_REASON_SHIFT_JOB_SETTINGS,
  ADD_EDIT_BOOKING_DIALOG_SETTINGS,
} from "../../../constants/agency-settings/job-settings";

export default {
  name: "UpdateBookingDialog",
  props: {
    header: String,
    name: String,
    user: Object,
    passedData: Object,
    title: String,
    keyTitles: {
      type: Array,
      default: () => ["name"],
    },
    // Selected date for Booking only
    selectedDate: String,
    value: Boolean,
    isAdd: Boolean,
    listFields: Array,
    // List models which is not showed
    listExcludeFields: {
      type: Array,
      default: () => [],
    },
    showCancel: {
      type: Boolean,
      default: false,
    },
    bookingRequirePaymentInfo: {
      type: Boolean,
      default: false,
    },
    listPrices: {
      type: Array,
      default: () => [],
    },
    listPriceServices: {
      type: Array,
      default: () => [],
    },
    categoryList: {
      type: String,
      default: "",
    },
    chargeClientWhenBooking: {
      type: Boolean,
      default: false,
    },
    chargeClientWhenAssign: {
      // Setting in profile type builder
      type: Boolean,
      default: false,
    },
    includeCandidatePayment: {
      type: Boolean,
      default: false,
    },
    employerTypesNotCharge: {
      type: Array,
    },
    listBookings: {
      type: Array,
      default: () => [],
    },
    // If number of children is more than that, additional fee will be added
    numberOfAllowedChildren: {
      type: Number,
      default: 1,
    },
    cancellationPolicy: {
      type: Array,
      default: () => [],
    },
    candidateList: {
      type: Array,
      default: () => [],
    },
    passedBookingField: Object,
    passedCreditCount: Number,
    isInApplicationForm: {
      type: Boolean,
      default: false,
    },
    profileBuilderID: Number,
    isFixedPoster: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      submitClicked: false,
      ACTION_TYPE: ACTION_TYPE,
      isShow: false,
      data: {},
      originalData: {},
      listRelatedJobs: [],
      listSelectedCandidates: [],
      listInterestedCandidates: [],
      listNotMatchCandidateIds: [],
      listFavoriteCandidateIds: [],
      isShowAddUserDialog: false,
      addingUserType: "",
      showFillerListForUpdate: false,
      isShowSelectFillerDialog: false,
      selectingFillerDate: null,
      mapSelectedCandidates: {},
      keepDialogOpen: false,
      addUserModel: "",
      bookingDateTimeInfo: {},
      CANCELLING_REASON_SHIFT_JOB_SETTINGS,
      ADD_EDIT_BOOKING_DIALOG_SETTINGS,
      posterCreditCount: null,
      listPosterChildren: [],
      listPosterPets: [],
      listPosterAddresses: [],
    };
  },
  components: {
    ModalDialog,
    StripePayment,
    BookingPriceInfo,
    JobFillerInfo,
    SelectFillerDialog,
    CandidateSelectionSection,
  },
  computed: {
    ...mapGetters([
      "agencyID",
      "availabilities",
      "weekAvailabilities",
      "candidateListMainInfo",
      "clientCanAssignShiftJob",
      "clientCanExpressInterestShiftJob",
      "clientCanAssignShiftJobApplicationForm",
      "shiftJobSelectionProfileFields",
      "candidateInfoSelectionFields", // list candidate info to show for avaialble candidates
      "customTextCancelingShiftJob",
      "onlyShowMatchedTags",
      "onlyShowMatchedLocations",
      "onlyShowMatchedZipcodes",
      "shiftJobStatusClientCanCancel",
      "isAgent",
      "jobTypeShortTermQuery",
      "clientCanSelectMultipleCandidates",
      "clientSelectionCandidateTypes",
      "candidateMatchingCategoryField",
      "clientSelectionCandidateStatuses",
      "hourlyServiceSelectionList",
      "employerShiftRequestEmails",
      "autoAssignCandidate",
      "messageNobodyAvailable",
      "candidatesCanSetRate",
      "textSelfSelectNobodyAvailable",
      "wordUsedForCandidates",
      "minChildrenAgeField",
      "agent",
      "agencyCurrencySign",
      "broadcastOnCreateJob",
      "chooseAddOptionSelectively",
      "shiftRequestMinimumHours",
      "doNotAskReasonClientCancelsShiftJob",
      "listModelRecalculatedWhenAssignJob",
      "doNotAutoPopulateAddress",
      "shiftJobCandidateUnassignStatus",
      "allowBookOnBlockedDate",
      "jobStatusForBlockedDate",
      "customMessageRequestForBlockedDates",
      "agencyLocations",
      "rushFeeInfo",
      "minDurationPerCategories",
      "minDurationPerTypes",
      "minDurationPerLocations"
    ]),
    creditCount() {
      return this.passedCreditCount || this.posterCreditCount;
    },
    employerShiftRequestEmailsByLocation() {
      let listLocations = this.getJobLocations(this.user, this.data);
      return this.getListEmailSubmissionNotification(
        this.employerShiftRequestEmails,
        this.tryGet(
          () =>
            this.$store.getters.agency.advance_setting
              .employer_shift_request_emails_by_locations
        ),
        listLocations
      );
    },
    bookingField() {
      if (this.passedBookingField) {
        return this.passedBookingField;
      }
      if (!this.listFields) {
        return null;
      }
      const dataField = this.listFields.find(
        (field) => field.dataKey === "list-booking-fields"
      );
      if (!dataField) {
        return null;
      }
      const listBookingFields = dataField.data;
      if (listBookingFields && listBookingFields.length) {
        if (listBookingFields.length === 1) {
          return listBookingFields[0];
        }
        if (this.data && this.data.type) {
          return listBookingFields.find(
            (field) => field.label === this.data.type
          );
        }
      }
    },
    sectionBuilderId() {
      if (!this.bookingField) {
        return null;
      }
      return this.bookingField.sectionBuilderId;
    },
    shiftRequestMinimumHoursPerClient() {
      const userTypes = this.user && this.user.types ? this.user.types : [];
      const userLocations =
        this.user && this.user.locations ? this.user.locations : [];
      let result = this.shiftRequestMinimumHours;
      let listMinValues = [];
      if (
        this.jobCategory &&
        this.minDurationPerCategories &&
        this.minDurationPerCategories.length
      ) {
        const minimumHoursPerCategories = this.minDurationPerCategories
          .filter((hour) => {
            return (
              hour.minimun_hours &&
              hour.categories &&
              hour.categories.includes(this.jobCategory)
            );
          })
          .map((hour) => parseInt(hour.minimun_hours));

        if (minimumHoursPerCategories.length) {
          listMinValues.push(Math.min(...minimumHoursPerCategories));
        }
      }
      if (
        this.minDurationPerTypes && this.minDurationPerTypes.length &&
        userTypes.length > 0
      ) {
        const minimumHoursPerClientTypes = this.minDurationPerTypes.filter((hour) => {
              return (
                hour.minimun_hours &&
                hour.client_types &&
                this.hasCommonElement(hour.client_types, userTypes)
              );
            })
            .map((hour) => parseInt(hour.minimun_hours));

        if (minimumHoursPerClientTypes.length) {
          listMinValues.push(Math.min(...minimumHoursPerClientTypes));
        }
      }
      if (
        this.minDurationPerLocations && this.minDurationPerLocations.length &&
        userLocations.length > 0
      ) {
        const minimumHoursPerClientLocations = this.minDurationPerLocations.filter((hour) => {
              return (
                hour.minimun_hours &&
                hour.locations &&
                this.hasCommonElement(hour.locations, userLocations)
              );
            })
            .map((hour) => parseInt(hour.minimun_hours));

        if (minimumHoursPerClientLocations.length) {
          listMinValues.push(Math.min(...minimumHoursPerClientLocations));
        }
      }

      if (listMinValues.length) {
        result = Math.min(...listMinValues);
      }
      return result;
    },
    isInvalidBookingDuration() {
      const compareCode = this.compareDuration(
        this.startDate,
        this.bookingDateTimeInfo.start_time,
        this.bookingDateTimeInfo.end_date,
        this.bookingDateTimeInfo.end_time,
        this.shiftRequestMinimumHoursPerClient
      );
      return compareCode === -1;
    },
    chargeClientWhenAssignCandidate() {
      if (this.chargeClientWhenAssign) {
        return true;
      }
      if (this.bookingField) {
        return this.bookingField.chargeClientWhenAssignCandidate;
      }
      return null;
    },
    hasPresetCandidateSelection() {
      if (!this.listFields) {
        return false;
      }
      return this.listFields.some(
        (field) =>
          field.type === FORM_TYPE.SLOT && field.presetFields === "Candidate Selection"
      );
    },
    listBookingDates() {
      return this.getListDateOfRepeatBooking(
        this.bookingDateTimeInfo,
        this.selectedDate
      );
    },
    numberOfBooking() {
      const repeatCount = this.getListDateOfRepeatBooking(
        this.bookingDateTimeInfo,
        this.selectedDate
      ).length;
      if (!this.data || !this.data.number_candidate) {
        return repeatCount;
      }
      return repeatCount * this.data.number_candidate;
    },
    listUniqueFields() {
      if (!this.listFields) {
        return [];
      }
      return this.listFields
        .filter((field) => field.isUnique)
        .map((field) => ({ model: field.model, label: field.label }));
    },
    numberOfBookingUsingCredit() {
      if (!this.creditCount) {
        // No booking uses credits
        return 0;
      }
      if (this.creditCount >= this.numberOfBooking) {
        // All bookings use credits
        return this.numberOfBooking;
      }
      // Some uses credit
      return this.creditCount;
    },
    canCancelJob() {
      if (!this.passedData) {
        return false;
      }
      return this.shiftJobStatusClientCanCancel.includes(
        this.passedData.status
      );
    },
    startDate() {
      return this.bookingDateTimeInfo.date || this.selectedDate;
    },
    endDate() {
      return this.bookingDateTimeInfo.end_date;
    },
    listPricesUpsertBooking() {
      let result = this.listPrices;
      if (this.user && this.user.membership_info && this.isAdd) {
        const membershipInfo = this.user.membership_info;
        if (membershipInfo.freePrices && membershipInfo.amount) {
          // Check if booking date is not expired
          const selectedDate = this.startDate;
          if (
            this.isDateInRange(
              selectedDate,
              membershipInfo.date,
              membershipInfo.duration
            )
          ) {
            // Count number of jobs in current month
            let listBookings = this.listBookings;
            if (this.user.id) {
              listBookings = listBookings.filter(
                (booking) => !booking.poster || booking.poster === this.user.id
              );
            }
            listBookings = listBookings.filter(
              (booking) => booking.status !== JOB_STATUSES.CANCELLED
            );
            // Find all possible valid ranges
            const listRanges = this.splitDateRange(
              membershipInfo.date,
              membershipInfo.duration
            );
            let selectedRange;
            const selectedDateStr = this.dateInDjangoFormat(
              this.addTimeToDate(selectedDate)
            );
            for (const range of listRanges) {
              if (selectedDateStr >= range[0] && selectedDateStr <= range[1]) {
                selectedRange = range;
              }
            }
            // Count total number of jobs which is in the same month with selected date
            const numBooking = listBookings.filter(
              (booking) =>
                booking.date >= selectedRange[0] &&
                booking.date <= selectedRange[1]
            ).length;
            if (numBooking < membershipInfo.amount) {
              result = result.filter(
                (price) => !membershipInfo.freePrices.includes(price.id)
              );
            }
          }
        }
      }
      return result;
    },
    listVisibleFields() {
      if (this.listFields == null) {
        return [];
      }
      let listFields = this.listFields.filter(
        (field) => !this.listExcludeFields.includes(field.model)
      );
      const additionalDateField = listFields.find(
        (field) => field.model === "additional_dates"
      );
      if (additionalDateField) {
        additionalDateField.minDuration =
          this.shiftRequestMinimumHoursPerClient;
      }
      // Check to insert option list for locations field
      const locationsField = listFields.find(
        (field) => field.model === "locations"
      );
      if (locationsField && !locationsField.optionList) {
        locationsField.optionList = this.agencyLocations;
        locationsField.setOutside = true;
      }
      if (!this.isFixedPoster) {
        const childrenSelectionField = listFields.find(
          (field) => field.model === "children_ids"
        );

        if (childrenSelectionField) {
          childrenSelectionField.optionList = this.listPosterChildren;
        }

        const petSelectionField = listFields.find(
          (field) => field.model === "pet_ids"
        );

        if (petSelectionField) {
          petSelectionField.optionList = this.listPosterPets;
        }

        const addressSelectionField = listFields.find(
          (field) => field.model === "address_id"
        );

        if (addressSelectionField) {
          addressSelectionField.optionList = this.listPosterAddresses;
        }
      }

      // Check show condition of people fields
      if (this.user) {
        listFields = listFields.filter((field) => {
          if (!field.showIf) {
            return true;
          }
          if (field.showIf.indexOf("people_") === 0) {
            return this.isItemShow(
              this.user,
              { ...field, showIf: field.showIf.replace("people_", "") },
              []
            );
          }
          return true;
        });
      }
      listFields = this.cloneArrayOfObject(listFields);
      listFields.forEach((field) => {
        if (field.showIf && field.showIf.indexOf("people_") === 0) {
          field.showIf = null;
        }
      });
      let result = listFields;
      // Insert a slot field for warning message
      const endTimeIndex = result.findIndex((x) => x.model == "end_time");
      if (endTimeIndex && endTimeIndex > -1) {
        result.splice(endTimeIndex + 1, 0, {
          type: FORM_TYPE.SLOT,
          label: "Warning Message",
        });
      }
      return result;
    },
    skipChargeUser() {
      if (this.employerTypesNotCharge && this.employerTypesNotCharge.length) {
        if (
          this.hasCommonElement(this.employerTypesNotCharge, this.user.types)
        ) {
          return true;
        }
      }
      return false;
    },
    hasPaymentField() {
      if (!this.bookingRequirePaymentInfo) {
        return false;
      }
      if (!this.user) {
        return false;
      }
      if (this.user.stripe_customer_id) {
        return false;
      }
      if (this.skipChargeUser) {
        return false;
      }
      if (!this.includeCandidatePayment) {
        // Use credits
        if (this.numberOfBooking <= this.creditCount) {
          return false;
        }
      }
      return true;
    },
    listDateTimesOfJobs() {
      return this.getListDateTimeOfJobs(this.bookingDateTimeInfo);
    },
    // Filter the availabilities which has date in range of job's date
    listRelatedAvailabilities() {
      if (this.availabilities) {
        // Get list dates from start_date to end_date of the booking
        const listDates = this.listDateTimesOfJobs.map(
          (datetimes) => datetimes.date
        );
        return this.availabilities.filter((availability) =>
          listDates.includes(availability.date)
        );
      } else {
        return [];
      }
    },
    listCandidatesIdHasAvailability() {
      let listIds1 = [];
      let listIds2 = [];
      if (this.listRelatedAvailabilities) {
        listIds1 = this.listRelatedAvailabilities.map(
          (availability) => availability.user
        );
      }
      if (this.weekAvailabilities) {
        listIds2 = this.weekAvailabilities.map(
          (availability) => availability.user
        );
      }
      const listIds = [...listIds1, ...listIds2];
      return [...new Set(listIds)]; // Deduplicate
    },
    // List all cand
    listFilteredCandidates() {
      let listCandidates = this.candidateListMainInfo || this.candidateList;
      if (!this.startDate || !listCandidates || !this.user) {
        return [];
      }
      // Check if candidate is in 'not match' relationships
      if (
        this.listNotMatchCandidateIds &&
        this.listNotMatchCandidateIds.length
      ) {
        listCandidates = listCandidates.filter(
          (candidate) => !this.listNotMatchCandidateIds.includes(candidate.id)
        );
      }

      // Check if candidate's tags must contains all client's tags
      if (this.onlyShowMatchedTags) {
        listCandidates = listCandidates.filter((candidate) =>
          this.containsAllElements(
            candidate.tags,
            this.user.tags,
            this.$store.getters.clientTagsRelevantMatching
          )
        );
      }
      // Check if candidate's locations must contains at least one of the client's locations
      if (
        this.onlyShowMatchedLocations &&
        this.user.locations &&
        this.user.locations.length
      ) {
        listCandidates = listCandidates.filter((candidate) =>
          this.hasCommonElement(candidate.locations, this.user.locations)
        );
      }
      if (this.onlyShowMatchedZipcodes) {
        let postalCode = this.data.postal_code;
        if (!postalCode && this.user && this.user.postal_code) {
          postalCode = this.user.postal_code;
        }
        if (postalCode) {
          listCandidates = listCandidates.filter(
            (candidate) =>
              candidate.working_postal_codes &&
              candidate.working_postal_codes.includes(postalCode)
          );
        }
      }
      if (
        this.clientSelectionCandidateTypes &&
        this.clientSelectionCandidateTypes.length
      ) {
        listCandidates = listCandidates.filter((candidate) =>
          this.hasCommonElement(
            candidate.types,
            this.clientSelectionCandidateTypes
          )
        );
      }
      if (
        this.clientSelectionCandidateStatuses &&
        this.clientSelectionCandidateStatuses.length
      ) {
        listCandidates = listCandidates.filter((candidate) =>
          this.clientSelectionCandidateStatuses.includes(candidate.status)
        );
      }

      if (
        this.candidateMatchingCategoryField &&
        this.data &&
        this.data.category
      ) {
        listCandidates = listCandidates.filter((candidate) => {
          const fieldVal =
            candidate[this.candidateMatchingCategoryField];
          if (!fieldVal) {
            return false;
          }
          if (Array.isArray(fieldVal)) {
            if (fieldVal.includes(this.data.category)) {
              return true;
            }
          } else {
            if (fieldVal == this.data.category) {
              return true;
            }
          }
          return false;
        });
      }

      // Filter candidates by min ages
      if (this.minChildrenAgeField && this.user && this.user.children) {
        const listChildrenWithAges = this.user.children.filter(
          (child) => child.birthday
        );
        if (listChildrenWithAges && listChildrenWithAges.length) {
          const minChildrenAge = Math.min(
            ...listChildrenWithAges.map((child) =>
              this.getAgeInYears(child.birthday)
            )
          );
          listCandidates = listCandidates.filter((candidate) => {
            if (candidate[this.minChildrenAgeField]) {
              let minAge = candidate[this.minChildrenAgeField];
              if (Array.isArray(minAge)) {
                minAge = Math.min(
                  ...minAge.map((age) => this.getNumberFromString(age))
                );
              } else {
                minAge = this.getNumberFromString(minAge);
              }
              return !minAge || minAge <= minChildrenAge;
            } else {
              return false;
            }
          });
        }
      }
      return listCandidates;
    },
    listPartlyAvailableCandidates() {
      const listFilterIds = this.listFilteredCandidates.map(
        (candidate) => candidate.id
      );
      const date = this.dateInDjangoFormat(this.startDate);
      const mapCandidateTimeBlocks = this.getMapAvailableCandidates(
        date,
        this.listRelatedAvailabilities || [],
        this.weekAvailabilities || [],
        this.listRelatedJobs || [],
        listFilterIds,
        this.listFilteredCandidates
      );
      const result = [];
      for (const candidateId of Object.keys(mapCandidateTimeBlocks)) {
        const candidate = this.listFilteredCandidates.find(
          (candidate) => candidate.id == candidateId
        );
        console.log(candidate);
        if (!candidate) {
          continue;
        }
        // Check exceed max job daily
        const isExceed = this.isExceedMaxJobDaily(
          candidate,
          this.listRelatedJobs,
          this.bookingDateTimeInfo,
          this.listDateTimesOfJobs
        );
        if (isExceed) {
          continue;
        }
        result.push({
          candidate: candidate,
          blocks: mapCandidateTimeBlocks[candidateId],
          isExceed: isExceed,
        });
      }
      return result;
    },
    listAvailableCandidatesAllBookings() {
      return this.listFilteredCandidates.filter((candidate) =>
        this.listCandidatesIdHasAvailability.includes(candidate.id)
      );
    },
    listAvailableCandidates() {
      const booking = this.bookingDateTimeInfo;
      // This is the list of candidates displayed when a single job is clicked on
      return this.listFilteredCandidates
        .filter((candidate) =>
          this.listCandidatesIdHasAvailability.includes(candidate.id)
        )
        .filter((candidate) => {
          return (
            !this.isAvailabilityConflict(
              candidate,
              this.listRelatedAvailabilities,
              this.weekAvailabilities || [],
              this.listDateTimesOfJobs
            ) &&
            !this.isTimeConflict(candidate, this.listRelatedJobs, booking) &&
            !this.isTimeOffConflict(
              candidate,
              this.listRelatedAvailabilities,
              this.listDateTimesOfJobs
            ) &&
            !this.isExceedMaxJobDaily(
              candidate,
              this.listRelatedJobs,
              booking,
              this.listDateTimesOfJobs
            )
          );
        });
    },
    hasSelectInterestedCandidateSelection() {
      return (
        this.clientCanExpressInterestShiftJob &&
        (!this.passedData || !this.passedData.filler)
      );
    },
    hasFillerSelection() {
      if (this.isInApplicationForm) {
        return this.clientCanAssignShiftJobApplicationForm;
      }
      return (
        this.clientCanAssignShiftJob &&
        (!this.passedData ||
          !this.passedData.filler ||
          this.showFillerListForUpdate)
      );
    },
  },
  methods: {
    ...mapActions([
      "loadAvailabilities",
      "loadWeekAvailabilities",
      "loadCandidateListMainInfo",
      "loadCandidateInfoSelectionFields",
      "getRelationshipsByEmployer",
      "reloadCandidateListMainInfo",
      "reloadEmployerListMainInfo",
      "unassignShiftJob",
      "setMapJobNumberOfMonth",
    ]),
    refreshData() {
      this.data = { ...this.data };
    },
    hideModal() {
      this.isShow = false;
      this.$emit("input", false);
    },
    async showModal() {
      if (
        this.hasFillerSelection ||
        this.hasSelectInterestedCandidateSelection ||
        this.autoAssignCandidate
      ) {
        this.listSelectedCandidates = [];
        this.listInterestedCandidates = [];
        // Initialize candidate selections
        if (this.passedData.filler) {
          const candidate = this.listFilteredCandidates.find(
            (candidate) => candidate.id === this.passedData.filler
          );
          if (candidate) {
            this.listSelectedCandidates = [candidate];
          }
        }
        await this.loadAvailabilities();
        await this.loadWeekAvailabilities();
        await this.loadCandidateInfoSelectionFields();
        if (this.user && this.user.id) {
          await this.loadCandidateListMainInfo();
          this.loadNotMatchRelationships();
          this.loadFavoriteCandidates();
        }
        this.getListRelatedJob();
        this.showFillerListForUpdate = false;
      }
      this.posterCreditCount = null;
      this.isShow = true;
    },
    async loadNotMatchRelationships() {
      const listRelationships = await this.getRelationshipsByEmployer({
        id: this.user.id,
        status: "Do Not Match",
      });
      this.listNotMatchCandidateIds = listRelationships.map(
        (relationship) => relationship.candidate
      );
    },
    async loadFavoriteCandidates() {
      const listRelationships = await this.getRelationshipsByEmployer({
        id: this.user.id,
        status: "Favorite",
      });
      this.listFavoriteCandidateIds = listRelationships.map(
        (relationship) => relationship.candidate
      );
    },
    async getListRelatedJob() {
      if (!this.hasFillerSelection && !this.autoAssignCandidate) {
        return;
      }
      // Get list related jobs
      const res = await axios.get(
        `/get-all-jobs/?job_type=${this.jobTypeShortTermQuery}&agency=${this.agencyID}`
      );
      this.listRelatedJobs = res.data.jobs;
      if (!this.isAdd && this.passedData && this.passedData.id) {
        this.listRelatedJobs = this.listRelatedJobs.filter(
          (job) => job.id !== this.passedData.id
        );
      }
    },
    isPaymentFieldInvalid() {
      // Check if payment information is invalid
      const invalidPaymentEl = document.getElementById(
        STRIPE_PAYMENT_ERROR_IDS.INVALID
      );
      if (invalidPaymentEl) {
        return true;
      }
      // Check if payment information is empty
      const emptyPaymentEl = document.getElementById(
        STRIPE_PAYMENT_ERROR_IDS.EMPTY
      );
      if (emptyPaymentEl) {
        return true;
      }
      return false;
    },
    handleClickSaveButton() {
      // Check missing date of additional dates
      if (this.data.additional_dates) {
        if (this.data.additional_dates.some((item) => !item.date)) {
          this.showErrorDialog("MISSING_DATE_OF_ADDITIONAL_DATES_ERROR_DIALOG");
          return;
        }
        if (this.data.additional_dates.some((item) => item.invalidDuration)) {
          this.showErrorDialog({
            key: "BOOKING_DURATION_TOO_SHORT_ERROR",
            params: [this.shiftRequestMinimumHoursPerClient],
          });
          return;
        }
      }
      if (this.isPastDate(this.startDate)) {
        this.showConfirmDialog({
          key: "BOOKING_IN_PAST_DATE_CONFIRM_DIALOG",
          onAcceptCallback: this.handleSaveJob,
        });
      } else {
        this.handleSaveJob();
      }
    },
    async handleSaveJob() {
      // Normalize startTime, endTime inside additional_dates
      if (this.data.additional_dates) {
        this.data.additional_dates.forEach((item) => {
          if (item.start_time) {
            item.start_time = this.getTimeString(item.start_time);
          }
          if (item.end_time) {
            item.end_time = this.getTimeString(item.end_time);
          }
        });
      }

      if (this.bookingField && !this.$store.getters.isAgent) {
        if (this.isAdd) {
          // Check if booking is not allowed to add
          if (this.bookingField.numberOfHoursAddBooking) {
            if (
              this.calculateHoursFromNow(
                this.startDate,
                this.getTimeString(this.data.start_time)
              ) < Number(this.bookingField.numberOfHoursAddBooking)
            ) {
              if (
                this.bookingField.notAllowAddBookingMessage &&
                this.bookingField.notAllowAddBookingMessage.length
              ) {
                this.showErrorDialog({
                  innerHtml: this.bookingField.notAllowAddBookingMessage,
                });
              } else {
                this.showErrorDialog({
                  key: "CANNOT_ADD_BOOKING_WITHIN_X_HOURS",
                  params: [this.bookingField.numberOfHoursAddBooking],
                });
              }
              return;
            }
          }
        } else {
          // Check if booking is not allowed to edit
          if (this.bookingField.numberOfHours) {
            if (
              this.calculateHoursFromNow(this.data.date, this.data.start_time) <
              Number(this.bookingField.numberOfHours)
            ) {
              if (this.bookingField.notAllowEditBookingMessage) {
                this.showErrorDialog({
                  innerHtml: this.bookingField.notAllowEditBookingMessage,
                });
              } else {
                this.showErrorDialog({
                  key: "CANNOT_EDIT_BOOKING_WITHIN_X_HOURS",
                  params: [this.bookingField.numberOfHours],
                });
              }
              return;
            }
          }
        }
      }

      const selectedDate = this.startDate;

      // Check if booking in list blocked date
      if (
        !this.isAgent &&
        this.isAdd &&
        this.$store.getters.agencyPublic &&
        this.$store.getters.agencyPublic.shift_request_full_dates
      ) {
        if (
          this.$store.getters.agencyPublic.shift_request_full_dates.includes(
            this.dateInDjangoFormat(selectedDate)
          )
        ) {
          if (this.allowBookOnBlockedDate) {
            this.showResultDialog({
              innerHtml: this.customMessageRequestForBlockedDates,
            });
            this.data.is_blocked_date = true;
            this.data.status = this.jobStatusForBlockedDate;
          } else {
            this.showResultDialog("BOOKING_ON_BLOCKED_DATES_RESULT_DIALOG");
            let additionalInfo = "";
            if (this.data.start_time && this.data.end_time) {
              additionalInfo += `Booking Time: ${this.getTimeString(
                this.data.start_time
              )} - ${this.getTimeString(this.data.end_time)}`;
            }
            if (this.data.end_date) {
              additionalInfo += `<br/>End Date ${this.addTimeToDate(
                this.data.end_date
              ).toDateString()}`;
            }
            if (this.user && this.user.id) {
              this.sendEmail(
                {
                  ...this.$store.getters.bookingOnBlockedDateAdminNotification,
                  recipients: this.employerShiftRequestEmailsByLocation,
                },
                this.user.first_name,
                this.user.last_name,
                this.addTimeToDate(selectedDate).toDateString(),
                this.user.email,
                additionalInfo
              );
            }
            return;
          }
        }
      }

      this.submitClicked = true;
      // this.broadcastAppNotification();
      // Check to show warning for missing fields
      const isContinue = await this.validateBaseInputValues(
        this.data,
        this.listVisibleFields
      );
      if (!isContinue) {
        return;
      }
      // Check for missing start_time and end_time
      const minHours = this.shiftRequestMinimumHoursPerClient;
      const compareCode = this.compareDuration(
        selectedDate,
        this.data.start_time,
        this.data.end_date,
        this.data.end_time,
        minHours
      );
      if (compareCode === -3) {
        this.showErrorDialog(this.$store.getters.endDateBeforeStartDateError);
        return;
      }
      if (compareCode === -1 && !this.$store.getters.isAgent) {
        this.showErrorDialog({
          ...this.$store.getters.bookingDurationTooShortError,
          params: [minHours],
        });
        return;
      }
      if (compareCode === -2) {
        this.data.end_date = this.getNextDate(selectedDate);
        // Check booking duration with new end_date
        if (!this.$store.getters.isAgent) {
          const compareCode2 = this.compareDuration(
            selectedDate,
            this.data.start_time,
            this.data.end_date,
            this.data.end_time,
            minHours
          );
          if (compareCode2 === -1) {
            this.showErrorDialog({
              ...this.$store.getters.bookingDurationTooShortError,
              params: [minHours],
            });
            return;
          }
        }
      }
      // Check if payment information is input
      if (this.hasPaymentField) {
        if (this.isPaymentFieldInvalid()) {
          this.showErrorDialog("PAYMENT_INFORMATION_REQUIRED");
          return;
        }
      }
      const priceInfo = {
        client_rate: this.$refs.priceInfo.clientRate || 0,
        agency_fee: this.$refs.priceInfo.agencyRate || 0,
        travel_fee: this.$refs.priceInfo.travelFeePerBooking || 0,
        rush_fee: this.$refs.priceInfo.rushFeePerBooking || 0,
        per_booking_agency_fee: this.$refs.priceInfo.perBookingAgencyFee || 0,
        per_booking_candidate_fee:
          this.$refs.priceInfo.perBookingCandidateFee || 0,
        admin_fee: this.$refs.priceInfo.adminFeePerBooking || 0,
        admin_fee_subtraction:
          this.$refs.priceInfo.adminFeeSubstractionPerBooking || 0,
        total_discount: this.$refs.priceInfo.totalDiscount || 0,
      };
      if (priceInfo.rush_fee && this.rushFeeInfo) {
        if (this.rushFeeInfo.listDates === this.listBookingDates) {
          priceInfo.fee_details = {
            rush_fee: this.rushFeeInfo.listFees,
          };
        }
      }
      const candidateFee = this.$refs.priceInfo.candidateFee;
      if (candidateFee) {
        priceInfo["total_candidate_pay"] = candidateFee || 0;
        priceInfo["candidate_rate"] = null;
      } else {
        priceInfo["candidate_rate"] = this.$refs.priceInfo.candidateRate || 0;
        priceInfo["total_candidate_pay"] = null;
      }
      if (this.data.title) {
        let listPriceServices = this.hourlyServiceSelectionList;
        if (this.listPriceServices && this.listPriceServices.length) {
          listPriceServices = this.listPriceServices;
        }
        const price = listPriceServices.find(
          (price) => price.name === this.data.title
        );
        if (!price) {
          return;
        }
        if (price.is_price_expession) {
          priceInfo["candidate_rate"] =
            this.getPriceFromExpression(
              this.user,
              this.data,
              price.price_expression1,
              this.selectedDate
            ) || 0;
          priceInfo["client_rate"] =
            this.getPriceFromExpression(
              this.user,
              this.data,
              price.price_expression2,
              this.selectedDate
            ) || 0;
        } else {
          priceInfo["candidate_rate"] = price.price1 || 0;
          priceInfo["client_rate"] = price.price2 || 0;
        }
      }
      if (
        this.candidatesCanSetRate &&
        this.listSelectedCandidates &&
        this.listSelectedCandidates.length
      ) {
        const candidateRate = this.listSelectedCandidates[0].rate;
        if (candidateRate) {
          priceInfo["candidate_rate"] = candidateRate;
        }
      }

      // Check if client_rate is defined in the form
      if (
        this.listVisibleFields.some((field) => field.model === "client_rate")
      ) {
        if (this.data.client_rate) {
          priceInfo.client_rate = this.data.client_rate;
        }
      }

      let assignees = this.listSelectedCandidates;
      // Filter out the candidate which is not in the selection list (user may change date time after selecting filler)
      const listAvailableCandidateIds = this.listAvailableCandidates
        ? this.listAvailableCandidates.map((user) => user.id)
        : [];
      if (assignees) {
        assignees = assignees.filter((candidate) =>
          listAvailableCandidateIds.includes(candidate.id)
        );
      }
      // Assign automatically
      if (this.autoAssignCandidate) {
        // Job is not assigned
        if (!this.data.filled && !this.listSelectedCandidates.length) {
          if (
            this.listAvailableCandidates &&
            this.listAvailableCandidates.length
          ) {
            assignees = [this.listAvailableCandidates[0]];
          } else {
            this.keepDialogOpen = false;
            this.showResultDialog({
              title: this.messageNobodyAvailable,
              closeLabel: "OK",
              onCloseCallback: this.emitDataOnSubmit,
              onCloseCallbackData: {
                priceInfo: priceInfo,
                assignees: assignees,
              },
            });
            return;
          }
        }
      }
      // Check if booking date/time is changed
      if (
        this.clientCanAssignShiftJob &&
        this.isChangeBookingDateTime() &&
        this.passedData.filler &&
        this.showFillerListForUpdate == false
      ) {
        await this.loadAvailabilities();
        await this.loadWeekAvailabilities();
        await this.loadCandidateInfoSelectionFields();
        if (this.user && this.user.id) {
          await this.loadCandidateListMainInfo();
        }
        let listCandidates = this.candidateListMainInfo || this.candidateList;
        const filler = listCandidates.find(
          (cand) => cand.id === this.passedData.filler
        );
        // Check if the filler is still available for the job
        if (filler) {
          if (
            this.isAvailabilityConflict(
              filler,
              this.listRelatedAvailabilities,
              this.weekAvailabilities || [],
              this.listDateTimesOfJobs,
              true
            ) ||
            this.isTimeConflict(filler, this.listRelatedJobs, {
              ...this.bookingDateTimeInfo,
              id: this.passedData.id,
            }) ||
            this.isTimeOffConflict(
              filler,
              this.listRelatedAvailabilities,
              this.listDateTimesOfJobs
            )
          ) {
            // Unassign candidates
            await this.unassignShiftJobAndNotification(
              this.passedData,
              this.user,
              filler.id
            );
            this.data.status =
              this.shiftJobCandidateUnassignStatus || "Requested";
            this.data.filled = false;
            this.data.filler = null;
            this.data.filler_name = "";
            this.data.filled_date = null;
            this.showResultDialog("RESELECT_JOB_FILLER_RESULT_DIALOG");
            if (this.user && this.user.id) {
              this.loadNotMatchRelationships();
              this.loadFavoriteCandidates();
            }
            this.showFillerListForUpdate = true;
            // Save data and let user select filler later (still open the dialog)
            this.keepDialogOpen = true;
            this.emitDataOnSubmit(
              { priceInfo: priceInfo, assignees: assignees },
              false
            );
            return;
          }
        }
      }
      this.keepDialogOpen = false;
      this.emitDataOnSubmit({ priceInfo: priceInfo, assignees: assignees });
    },
    isChangeBookingDateTime() {
      if (this.isAdd) {
        return false;
      }
      if (!this.passedData.id) {
        return false;
      }
      if (this.data.date && this.passedData.date) {
        if (
          this.dateInDjangoFormat(this.data.date) !==
          this.dateInDjangoFormat(this.passedData.date)
        ) {
          return true;
        }
      }
      if (this.data.start_time && this.passedData.start_time) {
        if (
          this.getTimeString(this.passedData.start_time) !==
          this.getTimeString(this.data.start_time)
        ) {
          return true;
        }
      }
      if (this.data.end_time && this.passedData.end_time) {
        if (
          this.getTimeString(this.passedData.end_time) !==
          this.getTimeString(this.data.end_time)
        ) {
          return true;
        }
      }
      return false;
    },
    async emitDataOnSubmit({ priceInfo, assignees }, hasResultDialog = true) {
      if (this.clientCanExpressInterestShiftJob) {
        if (
          !this.data.list_interest_candidate_ids ||
          !this.data.list_interest_candidate_ids.length
        ) {
          this.data.list_interest_candidate_ids =
            this.listInterestedCandidates.map((candidate) => candidate.id);
        }
      }
      this.$emit("saved", {
        actionType: this.isAdd ? ACTION_TYPE.ADD : ACTION_TYPE.UPDATE,
        data: {
          ...this.data,
          ...priceInfo,
          section_builder_id: this.sectionBuilderId,
          profile_builder_id: this.profileBuilderID,
          unique_fields: this.listUniqueFields,
          map_date_filler: this.mapSelectedCandidates,
        },
        assignees: assignees,
        numberOfBooking: this.numberOfBooking,
        hasResultDialog: hasResultDialog,
      });
    },
    handleAfterSavingData(listBookingIds) {
      return new Promise(async (resolve) => {
        // Check if charge client when creating booking
        try {
          let isCreateStripeCustomer = false;
          if (
            (this.chargeClientWhenBooking ||
              this.chargeClientWhenAssignCandidate) &&
            this.isAdd &&
            !this.skipChargeUser
          ) {
            // Calculate amount
            let amount = 0;
            if (this.includeCandidatePayment) {
              amount = this.getTotalFee();
            } else {
              amount = this.getAgencyFee();
            }
            if (amount) {
              let isCharged = false;
              if (this.hasPaymentField) {
                if (
                  this.chargeClientWhenBooking ||
                  (this.chargeClientWhenAssignCandidate && this.data.filler)
                ) {
                  // Create stripe field and charge
                  await this.$refs.stripePayment.createCustomer(
                    this.user,
                    {
                      amount: amount,
                    },
                    listBookingIds[0],
                    `Booking fee (Booking Date: ${this.getDateString(
                      this.startDate
                    )})`
                  );
                  isCharged = true;
                } else {
                  await this.$refs.stripePayment.createCustomer(this.user);
                }
                this.$emit("reloadUser");
                isCreateStripeCustomer = true;
              } else if (this.user.stripe_customer_id) {
                if (
                  this.chargeClientWhenBooking ||
                  (this.chargeClientWhenAssignCandidate && this.data.filler)
                ) {
                  // Charge
                  await axios.post(
                    `/stripe-collect-payment-from-existing-customer/`,
                    {
                      stripe_payer_account: this.user.stripe_customer_id,
                      stripe_payee_account:
                        this.$store.getters.agency.stripe_account_id,
                      amount: Math.round(parseFloat(amount).toFixed(2) * 100),
                      receipt_email: this.user.email,
                      currency:
                        this.user.currency ||
                        this.$store.getters.agency.currency,
                      log: true,
                      agency: this.$store.getters.agencyID,
                      user: this.user.id,
                      category: "Job",
                      related_id: listBookingIds[0],
                      description: `Charge Client when create booking (Booking Date: ${this.getDateString(
                        this.startDate
                      )} - ID: ${listBookingIds[0]}`,
                    }
                  );
                  isCharged = true;
                }
              }
              if (isCharged && listBookingIds) {
                const requestBody = {
                  date_client_charged: this.dateInDjangoFormat(new Date()),
                };
                if (this.includeCandidatePayment) {
                  requestBody.total_client_charge =
                    this.roundNumberTwoDigits(amount);
                }
                for (const bookingId of listBookingIds) {
                  // Update booking information
                  await axios.patch(`/api/jobs/${bookingId}/`, requestBody);
                }
              }
              if (this.chargeClientWhenAssignCandidate && !isCharged) {
                const amountPerBooking = amount / listBookingIds.length;
                // Update user information to charge client when candidate is assigned
                for (const bookingId of listBookingIds) {
                  // Update booking information
                  await axios.patch(`/api/jobs/${bookingId}/`, {
                    charge_client_on_assign:
                      this.roundNumberTwoDigits(amountPerBooking),
                  });
                }
              }
            }
          }

          if (this.hasPaymentField && !isCreateStripeCustomer) {
            await this.$refs.stripePayment.createCustomer(this.user);
            this.$emit("reloadUser");
          }
          if (!this.keepDialogOpen) {
            this.hideModal();
          }
        } catch (e) {
          if (!this.keepDialogOpen) {
            this.hideModal();
          }
        }
        resolve();
      });
    },
    showDeleteBookingConfirmDialog() {
      this.showConfirmDialog({
        ...this.$store.getters.deleteBookingConfirmDialog,
        onAcceptCallback: this.deleteBooking,
      });
    },
    deleteBooking() {
      this.hideModal();
      this.$emit("saved", { actionType: ACTION_TYPE.DELETE, data: this.data });
    },
    handleClickCloseButton() {
      if (this.isDisableConfirmCancellation()) {
        this.hideModal();
        return;
      }
      // Check if data is unchanged
      if (
        this.isUnchangedObject(
          this.originalData,
          this.data,
          this.listVisibleFields
        )
      ) {
        this.hideModal();
        return;
      }
      this.showConfirmDialog({
        ...this.$store.getters.cancelConfirmDialog,
        onAcceptCallback: this.hideModal,
      });
    },
    // Fee client pay agency per booking
    getAgencyFee() {
      let amount = 0;

      if (!this.$refs.priceInfo) {
        return this.roundNumberTwoDigits(amount);
      }

      const perBookingAgencyFee = this.$refs.priceInfo.totalPerBookingAgencyFee;
      if (perBookingAgencyFee) {
        amount += Number(perBookingAgencyFee);
      }
      // Rush fee is fee pay to agency
      const rushFee = this.$refs.priceInfo.rushFee;
      if (rushFee) {
        amount += Number(rushFee);
      }
      const agencyRate = this.$refs.priceInfo.agencyRate;
      if (agencyRate) {
        amount += this.$refs.priceInfo.bookingDuration * Number(agencyRate);
      }
      // Admin fee
      const adminFee = this.$refs.priceInfo.adminFee;
      if (adminFee) {
        amount += Number(adminFee);
      }
      const adminFeeSubstraction = this.$refs.priceInfo.adminFeeSubstraction;
      if (adminFeeSubstraction) {
        amount += Number(adminFeeSubstraction);
      }
      const totalDiscount = this.$refs.priceInfo.totalDiscount;
      if (totalDiscount) {
        amount = amount - Number(totalDiscount);
      }
      return this.roundNumberTwoDigits(amount);
    },
    // Fee client pay agency and candidate per booking
    getTotalFee() {
      let amount = 0;

      if (!this.$refs.priceInfo) {
        return this.roundNumberTwoDigits(amount);
      }

      const flatRate = this.$refs.priceInfo.totalFlatRate;
      if (flatRate) {
        amount += flatRate;
      }
      return this.roundNumberTwoDigits(amount);
    },
    handleClickUserButton({ btnId, model, el }) {
      if (btnId === "add-client") {
        this.addingUserType = "employer";
        this.addUserModel = model;
        this.isShowAddUserDialog = true;
      } else if (btnId === "view-client") {
        this.showUserProfileDialog(this.data.poster, false);
      } else if (btnId === "add-candidate") {
        this.addingUserType = "candidate";
        this.addUserModel = model;
        this.isShowAddUserDialog = true;
      } else if (btnId === "view-filler") {
        this.showUserProfileDialog(this.data.filler, true);
      } else if (btnId === "view-tentative-filler") {
        this.showUserProfileDialog(this.data.tentatively_filler, true);
      } else if (btnId === "add-option") {
        this.showInputDialog({
          title: "New Options",
          listFields: [
            {
              type: FORM_TYPE.TEXTBOX,
              model: "option",
            },
          ],
          onSubmitCallback: async (info) => {
            console.log(el);
            await axios.patch(`/profile-builder/${el.builderId}/`, {
              action_type: "Add Option",
              option: info.option,
              model: model,
            });
            await this.reloadProfileBuilderList();
          },
        });
      }
    },
    async handleClickTextboxButton({ btnId, model }) {
      if (btnId === "check-for-existing") {
        const res = await axios.post("/check-existing-job/", {
          model: model,
          agency: this.agencyID,
          value: this.data[model],
        });
        this.showResultDialog({ title: res.data.message, noToast: true });
      }
    },
    handleClickSelectIndividualBooking() {
      this.isShowSelectFillerDialog = true;
    },
    handleUpdateSelection(model) {
      if (model === "children_ids") {
        if (this.data.children_ids) {
          this.data.number_children = this.data.children_ids.length;
        } else {
          this.data.number_children = null;
        }
      }
      this.$nextTick(() => {
        this.refreshData();
      });
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.bookingDateTimeInfo = { date: this.selectedDate };
          return;
        }
        const listKeys = [
          "date",
          "end_date",
          "start_time",
          "end_time",
          "repeat",
          "repeat_end_date",
          "repeat_count",
          "repeat_type",
          "repeat_weekdays",
          "additional_dates",
        ];
        // Check if data is unchanged
        if (value) {
          let isChange = false;
          for (const key of listKeys) {
            if (!this.selectedDate || key !== "date") {
              if (value[key] != this.bookingDateTimeInfo[key]) {
                isChange = true;
                break;
              }
            }
          }
          if (!isChange) {
            return;
          }
        }
        const result = {};

        for (const key of listKeys) {
          result[key] = this.data[key];
        }
        this.bookingDateTimeInfo = {
          ...result,
          date: value.date || this.selectedDate,
        };
      },
    },
    value: {
      immediate: true,
      handler(value) {
        if (value === true) {
          this.submitClicked = false;
          this.data = { ...this.passedData };
          if (
            !this.data.number_children &&
            this.tryGet(() => this.user.children.length)
          ) {
            this.data["number_children"] = this.user.children.length;
            this.data.children_ids = this.user.children.map(
              (child) => child.id
            );
          }
          if (!this.data.end_date) {
            this.data.end_date = this.selectedDate;
          }
          this.originalData = { ...this.data };
          if (this.isAdd && this.broadcastOnCreateJob) {
            this.data.is_broadcast = true;
          }
          this.showModal();
        } else {
          this.hideModal();
        }
      },
    },
    isShow: {
      immediate: true,
      handler() {
        this.$emit("input", this.isShow);
      },
    },
    startDate: {
      immediate: true,
      handler(val) {
        if (val) {
          this.data.end_date = val;
        }
      },
    },
    isShow: {
      immediate: true,
      handler() {
        this.$emit("input", this.isShow);
      },
    },
    listAvailableCandidates: {
      immediate: true,
      handler() {
        if (!this.isAdd) {
          return;
        }
        // Check if list selected candidates is still in the available list
        let listAvailableIds = [];
        if (this.listAvailableCandidates) {
          listAvailableIds = this.listAvailableCandidates.map(
            (candidate) => candidate.id
          );
        }
        const listCandidateNoLongerAvailables = [];
        for (const candidate of this.listSelectedCandidates) {
          if (!listAvailableIds.includes(candidate.id)) {
            listCandidateNoLongerAvailables.push(candidate);
          }
        }
        if (!listCandidateNoLongerAvailables.length) {
          return;
        }
        const info = listCandidateNoLongerAvailables
          .map((user) => `${user.first_name} ${user.last_name}`)
          .join(", ");
        this.showResultDialog({
          key: "CANDIDATES_NO_LONGER_AVAILABLES",
          params: [info],
        });
        const listNotAvailableIds = listCandidateNoLongerAvailables.map(
          (user) => user.id
        );
        this.listSelectedCandidates = this.listSelectedCandidates.filter(
          (candidate) => !listNotAvailableIds.includes(candidate.id)
        );
      },
    },
    listSelectedCandidates: {
      immediate: true,
      async handler(val) {
        if (this.$store.getters.isRecalculatePriceOnAssignJob) {
          let fillerId;
          if (val && val.length) {
            fillerId = val[0].id;
          }
          await this.setMapJobNumberOfMonthOnAssignJob(
            this.data,
            this.startDate,
            fillerId
          );
          this.data.selected_filler_id = fillerId;
          if (fillerId) {
            this.listModelRecalculatedWhenAssignJob.forEach((model) => {
              this.data[model] = null;
            });
          }
          this.data = { ...this.data };
        }
        console.log(val);
      },
    },
  },
};
</script>

<style scoped>
.button-containers {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
}

.left-side-button {
  display: flex;
  flex-direction: row-reverse;
}

.right-side-button {
  flex-grow: 1;
  text-align: right;
}

.danger-button {
  margin-left: 0.5em;
}

@media (max-width: 600px) {
  .button-containers {
    display: block;
    text-align: center;
  }

  .left-side-button {
    margin-top: 8px;
    display: block;
  }

  .right-side-button {
    text-align: center;
  }

  .danger-button {
    margin-left: 0;
    margin-bottom: 8px;
  }
}

.selected-candidate {
  background-color: rgb(227 226 226);
}
</style>



// WEBPACK FOOTER //
// src/components/common/bookings/UpdateBookingDialog.vue